(() => {
  angular
    .module('gm.common.directives')
    .directive('gmLineInputControl', gmLineInputControlDirective);

  function gmLineInputControlDirective() {
    'ngInject';

    return {
      replace: true,
      require: 'ngModel',
      restrict: 'E',
      scope: {
        icon: '=?',
        optional: '@?',
        type: '@?',
        tip: '@?',
        maxLength: '@?'
      },
      templateUrl: 'modules/common/directives/line-input-control/line-input-control.html',
      transclude: true,
      link(scope, _element, _attrs, ctrl) {
        scope.value = '';

        scope.$watch(() => ctrl.$viewValue, (newValue) => {
          scope.value = newValue;
        });

        scope.$watch('value', (value) => {
          if (value && scope.maxLength && (value.length > scope.maxLength)) {
            ctrl.$setValidity('maxlength', false);
          } else {
            ctrl.$setValidity('maxlength', true);
          }
          ctrl.$setViewValue(value);
        });
      },
    };
  }
})();
